const AddTypeModal = ({ isOpen, onClose, newType, setNewType, onAdd }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-96 text-start shadow-xl">
        <h2 className="text-xl font-bold text-gray-800 mb-4">Add New Category</h2>

        <input
          type="text"
          value={newType}
          onChange={(e) => setNewType(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && onAdd()}
          placeholder="Enter type name..."
          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none mb-4"
 
        />

    <div className="flex justify-end gap-3 mt-6">
  <button
    onClick={onClose}
    className="px-4 py-2 rounded-lg bg-gray-100 text-gray-700 hover:bg-gray-200"
  >
    Cancel
  </button>

  <button
    onClick={onAdd}
    className="px-6 py-2 rounded-lg bg-black text-white text-sm hover:bg-gray-900"
  >
    Add
  </button>
</div>

      </div>
    </div>
  );
};

export default AddTypeModal;
